export default function convertImageFilter(path, replacer, substring = 'original') {
    if (!replacer || typeof replacer !== 'string') {
        return path;
    }

    return path.replace('/' + substring + '/', '/' + replacer + '/');
}
